import React, { useState } from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";

import DataGridBase from "./DataGridBase";
import { PaperComponentDraggable } from "./PaperComponentDraggable";

/**
 * Ventana de busqueda en modo dialogo, para elegir un registro de una lista.
 *
 * El registro se puede elegir de dos formas, igual que en el resto del sistema:
 * - con doble clic sobre la fila, que elige y cierra la ventana;
 * - seleccionando la fila con un clic y presionando el boton Aceptar.
 *
 * Es un wrapper de DataGridBase: las columnas, el loading y los filtros se los
 * pasa el que la usa.
 */
const DialogoBusqueda = ({
    // Datos de la ventana.
    open,
    onClose,
    titulo,
    columns = [],
    rows = [],
    loading = false,
    // Fila elegida y devuelta al confirmar.
    onAceptar,
    // Fila resaltada al hacer un clic.
    onSelect,
    rowKey = (row) => row.id,
    // Texto del boton de confirmacion.
    textoAceptar = "Aceptar",
    ancho = "md",
    // Filtros que se muestran encima de la lista.
    filtros = null,
    pageSize = 10,
    pageSizeOptions = [5, 10, 20, 50],
}) => {
    const [seleccion, setSeleccion] = useState(null);

    // Al cerrar se limpia la seleccion para que la ventana vuelva en blanco.
    const cerrar = () => {
        setSeleccion(null);
        onClose();
    };

    const elegir = (fila) => {
        setSeleccion(fila);

        if (onSelect) onSelect(fila);
    };

    const aceptar = () => {
        if (!seleccion) return;

        if (onAceptar) onAceptar(seleccion);

        setSeleccion(null);
    };

    // Al abrir la ventana se muestra limpia.
    const abrir = (estado) => {
        if (estado) setSeleccion(null);
    };

    return (
        <Dialog open={open} fullWidth maxWidth={ancho} onClose={cerrar} TransitionProps={{ onEnter: abrir }} PaperComponent={PaperComponentDraggable}>
            <DialogTitle id="draggable-dialog-title" style={{ cursor: "move" }}>
                <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                    {titulo}
                </Typography>
            </DialogTitle>
            <DialogContent>
                {filtros && (
                    <Box sx={{ paddingTop: "12px", paddingBottom: "8px" }}>{filtros}</Box>
                )}
                <Box sx={{ display: "grid", gridTemplateColumns: "1fr", paddingBottom: "4px" }}>
                    <DataGridBase
                        rows={rows}
                        columns={columns}
                        loading={loading}
                        showToolbar={false}
                        paginationTop={false}
                        pageSize={pageSize}
                        pageSizeOptions={pageSizeOptions}
                        disableRowSelectionOnClick={false}
                        onRowClick={(event) => { elegir(event.row); }}
                        onRowDoubleClick={(event) => {
                            if (onAceptar) onAceptar(event.row);
                        }}
                        getRowId={rowKey}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={cerrar}>{"Cerrar"}</Button>
                <Button variant="contained" disabled={!seleccion} onClick={aceptar}>
                    {textoAceptar}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DialogoBusqueda;